export default "__VITE_ASSET__DeLYeoJX__"